import Cookies from 'js-cookie';
import { useCallback, useEffect } from 'react';

import { useDispatch, useSelector } from '../../../react-redux';
import { setCallTags } from '../../../reducers/tag';
import {
  getCallTagListApi,
  updateCallTagApi,
  deleteCallTagApi,
  addCallTagApi,
  bindCallTagApi,
  unbindCallTagApi
} from '../api/call';
import tagSelector from '../selector';

const { parseConvTag, getConvTag, getConvTagTreeList } = tagSelector;
const entId = window.parseInt(Cookies.get('_enterprise_id'));

const useCallTag = props => {
  const { refresh = true } = props || {};
  const callTagSetting = useSelector(state => state.getIn(['tag', 'callTag']));
  const callTag = parseConvTag(callTagSetting);
  const { convTagMap: callTagMap, convTagTree: callTagTree } = getConvTagTreeList(callTagSetting);
  const dispatch = useDispatch();

  const handleGetCallTag = useCallback(() => {
    return getCallTagListApi({ entId }).then(res => {
      dispatch(setCallTags(res?.data));
      return res;
    });
  }, []);

  const handleGetCallTagById = useCallback(
    tagIds => {
      return getConvTag(tagIds, callTag);
    },
    [callTag]
  );

  useEffect(() => {
    if (refresh) {
      handleGetCallTag();
    }
  }, [refresh]);

  return {
    callTag,
    callTagSetting,
    callTagMap,
    callTagTree,
    handleGetCallTag,
    handleGetCallTagById,
    updateCallTagApi,
    deleteCallTagApi,
    addCallTagApi,
    bindCallTagApi,
    unbindCallTagApi
  };
};

export default useCallTag;
